import {
  get,
  post, //remove
} from '@/src/tools/server';
const getCustomerDBs = () => {
  return get(`/portal/store/customerdb/list`, {});
};

const getCustomerDB = (uuid) => {
  return get(`/portal/store​/customerdb​/${uuid}/fields`, {});
};

const getRegistration = (uuid) => {
  return get(`/portal/salesChannel/${uuid}/customer/registration`, {});
};

const postRegistration = (body) => {
  return post(`/portal/salesChannel/customer/registration`, body, {});
};

export { getCustomerDBs, getCustomerDB, getRegistration, postRegistration };
